import React from 'react';
import styles from './User.module.css';
import { Avatar, Menu, MenuItem, Tooltip } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { getAuth, signOut } from 'firebase/auth';
import { getAuthErrorMessageForCode } from '../../../common/firebase/auth-error.service';
import { useNavigate } from 'react-router';
import { ServiceManager } from '../../../services/service-manager';
import { severity } from '../../../common/models/severity.enum';

const User = ({ user, onLogout }) => {


    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        const auth = getAuth();
        onLogout();
        signOut(auth).then(() => {
            navigate('/auth/login');
        }).catch((error) => {
            ServiceManager.snackbarService.openSnackbar(getAuthErrorMessageForCode(error.code), severity.error);
        });
    }

    const resetPassword = () => {
        navigate('/auth/forgot-password');
    }

    const profile = () => {
        navigate('/auth/profile');
    }

    const deleteAccount = () => {
        navigate('/auth/delete-account');
    }

    const admin = () => {
        navigate('/admin');
    }

    return (<div className={styles.User} data-testid="User">
        <Tooltip title={user.email}>
            <Avatar
                data-testid="profile-button"
                className={styles.Avatar} aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick} sx={{ bgcolor: "white", color: "#2819FF", fontSize: 14}}>
                <span data-testid="user-avatar">{(user.email[0] + user.email[1]).toUpperCase()}</span>
            </Avatar>
        </Tooltip>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem data-testid="edit-profile-button" onClick={() => { handleClose(); profile(); }}>Profiel</MenuItem>
            <MenuItem data-testid="reset-password-button" onClick={() => { handleClose(); resetPassword(); }}>Wachtwoord wijzigen</MenuItem>
            <MenuItem data-testid="delete-account-button" onClick={() => { handleClose(); deleteAccount(); }}>Account Verwijderen</MenuItem>
            <MenuItem data-testid="logout-button" onClick={() => { handleClose(); logout(); }}>Uitloggen</MenuItem>
            {
                user.token?.claims?.roles?.includes('admin') &&
                <MenuItem data-testid="admin-button" onClick={() => { handleClose(); admin(); }}>Admin Paneel</MenuItem>
            }
        </Menu>
    </div>)
};

export default User;
